var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckTitleCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 1.33337C7.90016 1.33337 1.3335 7.90004 1.3335 16C1.3335 24.1 7.90016 30.6667 16.0002 30.6667C24.1002 30.6667 30.6668 24.1 30.6668 16C30.6668 7.90004 24.1002 1.33337 16.0002 1.33337ZM22.3575 13.52C22.4746 13.3862 22.5637 13.2304 22.6196 13.0616C22.6755 12.8928 22.6972 12.7146 22.6832 12.5374C22.6692 12.3601 22.6199 12.1875 22.5383 12.0295C22.4566 11.8716 22.3441 11.7316 22.2076 11.6178C22.071 11.504 21.913 11.4187 21.743 11.3668C21.5729 11.3149 21.3942 11.2976 21.2173 11.3158C21.0405 11.334 20.8691 11.3874 20.7132 11.4729C20.5572 11.5583 20.42 11.6741 20.3095 11.8134L14.5762 18.692L11.6095 15.724C11.358 15.4812 11.0212 15.3468 10.6716 15.3498C10.322 15.3528 9.98762 15.4931 9.74041 15.7403C9.49319 15.9875 9.35297 16.3219 9.34993 16.6715C9.34689 17.0211 9.48129 17.3579 9.72416 17.6094L13.7242 21.6094C13.8552 21.7403 14.012 21.8425 14.1847 21.9095C14.3574 21.9764 14.5422 22.0066 14.7272 21.9982C14.9122 21.9898 15.0935 21.943 15.2594 21.8606C15.4253 21.7783 15.5722 21.6623 15.6908 21.52L22.3575 13.52Z",
    fill: "#026F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTitleCart);
export default __webpack_public_path__ + "static/media/check-title-cart.3189a2677f655e7d991bd62452b8e0b8.svg";
export { ForwardRef as ReactComponent };